<template>
  <div class="design">
    <headd :mobile_title="mobile_title"></headd>
    <div class="banner">
      <img src="../../static/logo/banner.png" />
    </div>
    <div class="formbox container">
      <div class="box_title">填写信息</div>
      <div class="dbox_cell">
        <div class="dbox_name">姓名</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="formdata.name"
            placeholder="请输入姓名"
            class="input"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">手机号码</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="formdata.tel"
            placeholder="请输入手机号"
            class="input"
            maxlength="11"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">需求描述</div>
        <div class="dbox_input">
          <textarea
            class="textarea"
            v-model="formdata.service"
            placeholder="请输入"
          ></textarea>
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">设计师</div>
        <div class="dbox_input">
          <div class="select">
            <select v-model="designSelected" @change="getdesignSelected($event)"
              ><option v-for="item in designerSelect">{{
                item.name
              }}</option></select
            >
          </div>
        </div>
      </div>
      <div class="btn_save" @click="btn_save">提交</div>
      <div class="moredesign" @click="tomoredesign()">免费设计不够用，再设计一次 ☞</div>
    </div>
    <div class="designlist container">
      <div class="d_title">
        <div class="dt_icon"></div>
        设计师介绍
      </div>
      <div class="dt_item" v-for="item in designerList" :key="item.id">
        <div class="item_info">
          <img :src="item.avatarUrl" class="avtar" />
          <div class="i_info">
            <div class="i_name">
              {{ item.name }} | <span>{{ item.title }}</span>
            </div>
            <div class="i_jinli">工作经验{{ item.workyears }}年</div>
          </div>
        </div>
        <div class="item_tag">
          <div class="i_tag" v-for="item2 in item.service_advantage">
            {{ item2 }}
          </div>
        </div>
        <div class="item_intro">
          <div class="t">个人介绍：</div>
          {{ item.work_desc }}
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "../components/head";
import foot from "@/components/foot";
import { getlogodesign, getdesigner } from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "免费设计logo",
      designerList: [],
      designerSelect: [],
      designSelected: "请选择",
      formdata: {
        name: "",
        tel: "",
        service: "",
        designer: "",
        designerid: 0
      },
      index: 0
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getdesigner();
  },
  methods: {
    tomoredesign(){
       this.$router.push({
          path: "designlogopay"
        });
				
			},
    async getdesigner() {
      var _self = this;
      const res = await getdesigner();
      //console.log(res.data);
      _self.designerList = res.data.data.designer;
      _self.designerSelect = [
        {
          value: "请选择",
          name: "请选择"
        },
        ...res.data.data.designer
      ];
    },

    getdesignSelected(e) {
      var _self = this;
      //console.log(e.target.selectedIndex);
      //console.log(_self.designerSelect[1]);
      //_self.formdata.designer = e.target.value;
      if (parseInt(e.target.selectedIndex) > 0) {
        _self.formdata.designer =
          _self.designerSelect[e.target.selectedIndex].name;
        _self.formdata.designerid =
          _self.designerSelect[e.target.selectedIndex].id;
      }
    },
    async btn_save() {
      var _self = this;
      var data = _self.formdata;
      console.log(data);
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.name == "") {
        this.$toast("请输入名字");

        return false;
      }
      if (data.tel == "") {
        this.$toast("请输入电话");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.service == "") {
        this.$toast("请输入需求描述");

        return false;
      }

      if (data.designer == "") {
        this.$toast("请选择设计师");
        return false;
      }

      var parm = {
        uid: localStorage.getItem("userId"),
        tel: data.tel,
        name: data.name,
        service: data.service,
        designer: data.designer,
        designerid: data.designerid
      };

      const res = await getlogodesign(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.formdata = {};
        _self.index = 0;
        _self.designSelected = "请选择";
      }
    }
  },
  beforeCreate: function() {
    document.getElementsByTagName("body")[0].className = "body_back";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "body_back");
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.body_back {
  @media (max-width: 991px) {
    background: #f2f2f2;
  }
}
.formbox {
  width: 8rem;
  margin: auto;
  @media (max-width: 991px) {
    margin: 0.3rem 0.32rem;
    width: 6.86rem;
    padding: 0.4rem !important;
    height: auto;
    background: #ffffff;
    box-shadow: 0 0.04rem 0.14rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.2rem;
    flex-direction: column;
  }
}
.design {
  flex-direction: column;
  .banner {
    img {
      width: 100%;
      height: 360rpx;
    }
  }

  .designlist {
    width: 8rem;
    margin: 0 auto;
    flex-direction: column;
    display: flex;
    text-align: left;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0;
    }
    .d_title {
      width: 100%;
      align-items: center;
      margin-bottom: 0.4rem;
      display: flex;
      .dt_icon {
        width: 0.05rem;
        height: 0.26rem;
        background: #1395ff;
        border-radius: 0.03rem;
        margin-right: 0.1rem;
      }
      font-size: 0.26rem;
      color: #1b1c33;
      line-height: 0.37rem;
    }
    .dt_item {
      width: 100%;
      background: #ffffff;
      border-radius: 0rem;
      padding: 0.2rem 0.4rem;
      flex-direction: column;
      margin-bottom: 0.4rem;
      display: flex;
      border-bottom: 0.01rem solid #ccc;
      @media (max-width: 991px) {
        padding: 0.2rem 0.2rem;
      }
      .item_info {
        align-items: center;
        margin-bottom: 0.23rem;
        display: flex;
        .avtar {
          width: 1.26rem;
          height: 1.26rem;
          margin-right: 0.3rem;
          border-radius: 50%;
          background-color: #f2f2f2;
        }
        .i_info {
          flex-direction: column;
          .i_name {
            height: 0.37rem;
            font-size: 0.26rem;
            font-weight: bolder;
            color: #1b1c33;
            line-height: 0.37rem;
            margin-bottom: 0.15rem;
            span {
              font-size: 0.2rem;
            }
            @media (max-width: 991px) {
              font-size: 0.3rem;
              line-height: 0.37rem;
            }
          }
          .i_jinli {
            height: 0.28rem;
            font-size: 0.2rem;
            color: #1b1c33;
            line-height: 0.28rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.33rem;
            }
          }
        }
      }
      .item_tag {
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 0.12rem;
        display: flex;
        .i_tag {
          padding: 0 0.15rem;
          height: 0.33rem;
          background: rgba(19, 149, 255, 0.07);
          border-radius: 0.17rem;
          font-size: 0.2rem;
          color: #1395ff;
          margin-right: 0.2rem;
          margin-bottom: 0.2rem;
          @media (max-width: 991px) {
            font-size: 0.26rem;
          }
        }
      }
      .item_intro {
        display: flex;
        .t {
          font-size: 0.24rem;
          font-weight: bolder;
          width: 1.4rem;
          @media (max-width: 991px) {
            width: 3rem;
            font-size: 0.28rem;
          }
        }
        width: 100%;
        font-size: 0.18rem;
        line-height: 0.25rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }
    }
  }
}
.btn_save {
  margin: 0.5rem auto 0.5rem auto;
  width: 4.94rem;
  height: 0.7rem;
  line-height: 0.7rem;
  background: #ff545a;
  border-radius: 0.35rem;
  font-size: 0.24rem;
  text-align: center;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.moredesign {
		align-items: center;
		justify-content: center;
    text-align: center;
    cursor: pointer;
		font-size: 0.24rem;
		text-decoration: underline;
		margin-bottom: 0.2rem;
	 @media (max-width: 991px) {
          font-size: 0.28rem;
          
        }
	}
.box_title {
  @media (max-width: 991px) {
    font-size: 0.38rem;
    line-height: 0.38rem;
    margin-bottom: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/designlogo.vue